import { render } from "./LayoutAdmin.vue?vue&type=template&id=2b0e4431"
import script from "./LayoutAdmin.vue?vue&type=script&lang=js"
export * from "./LayoutAdmin.vue?vue&type=script&lang=js"

import "./LayoutAdmin.vue?vue&type=style&index=0&id=2b0e4431&lang=css"
script.render = render

export default script